import { render, staticRenderFns } from "./Modernization.vue?vue&type=template&id=12a6606a&scoped=true&"
import script from "./Modernization.vue?vue&type=script&lang=js&"
export * from "./Modernization.vue?vue&type=script&lang=js&"
import style0 from "./Modernization.vue?vue&type=style&index=0&id=12a6606a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a6606a",
  null
  
)

export default component.exports